import React from 'react';
import DateFnsUtils from '@date-io/dayjs';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useGlobal } from '@rcg/ui-react';
import IconCalendar from '../Icons/Calendar';
import { useStyles } from './index.style';
import 'dayjs/locale/de'; // germany
import 'dayjs/locale/da'; // danish
import 'dayjs/locale/es'; // spanish
import 'dayjs/locale/fr'; // french
import 'dayjs/locale/nb'; // norway
import 'dayjs/locale/it'; // italian
import 'dayjs/locale/sv'; // swiss
import 'dayjs/locale/zh-hk'; // hong kong

const localeMap = {
  es: 'es', // Spanish
  en: 'en', // Australia
  deu: 'de', // German
  fr: 'fr', // French
  zh: 'zh-hk', // Hong Kong
  it: 'it', // Italy
  no: 'nb', // Norway
  sv: 'sv', // Sweden
};

const DataPicker = (props) => {
  const { renderContent } = useGlobal();
  const classes = useStyles();

  const I18rccl = {
    invalidDate: renderContent('formBookingAmendInvalidDate', 'Invalid Date'),
  };
  const { helperText } = props;

  // default props
  const defaultProps = {
    ...props,
    ...{
      helperText:
        helperText && helperText.includes('must be a `date` type')
          ? I18rccl.invalidDate
          : helperText,
      InputLabelProps: {
        shrink: true,
      },
      InputAdornmentProps: { position: 'start' },
      InputProps: { disableUnderline: true },
      KeyboardButtonProps: {
        onFocus: (e) => {
          e.currentTarget.closest(`.${classes.root.split(' ')[0]}`).classList.add('icon-focused');
        },
        onBlur: (e) => {
          e.currentTarget
            .closest(`.${classes.root.split(' ')[0]}`)
            .classList.remove('icon-focused');
        },
      },
      keyboardIcon: <IconCalendar />,
    },
  };
  const { data } = useGlobal();

  return (
    <div
      className={[classes.root, typeof defaultProps.value !== 'object' ? 'touched' : ''].join(' ')}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[data.lang]}>
        <KeyboardDatePicker {...defaultProps} />
      </MuiPickersUtilsProvider>
    </div>
  );
};

export default DataPicker;
